import React from 'react';
import TopBar from '../components/top-bar/TopBar';

const PageLayout: React.FC = ({ children }) => {
    const className: any = children as any;

    return (
        <>
            <TopBar />
            <div className={'page-container ' + className?.props?.name + (className?.props?.name ? ' main-bar-display' : '')}>{children}</div>
        </>
    );
};

export default PageLayout;
